<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header" v-if="!modal" >Información del Bien</div>
          <b-form>
            <b-form-group
              label="Código"
              label-for="codigo"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="codigo"
                v-model.trim="$v.codigo.$model" 
                :state="codigoValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="codigoFeedback">
                {{ codigoInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Nombre"
              label-for="nombre"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombre"
                v-model.trim="$v.nombre.$model" 
                :state="nombreValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="nombreFeedback">
                {{ nombreInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Descripción"
              label-for="descripcion"
              :label-cols="labelCols"
              horizontal>
              <b-form-textarea
                id="descripcion"
                v-model="$v.descripcion.$model" 
                rows="5"
                max-rows="50"
                :state="descripcionValida"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="descripcionFeedback">
                {{ descripcionInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <app-rubro
              label="Rubro"
              :nombre="rubroNombre"
              :labelCols="labelCols"
              :valido="rubroValido"
              :lista="rubrosList"
              :msjInvalido="rubroInvalidoMsj"
              @validate="validate"
              @updated="rubroActualizado">
            </app-rubro>
            
           <b-form-group
              label="Cotización"
              label-for="cotizacion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cotizacion"
                v-model.trim="$v.cotizacion.$model" 
                :state="cotizacionValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="cotizacionFeedback">
                {{ cotizacionInvalidaMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Pje.Amortización"
              label-for="pjeAmortizacion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="pjeAmortizacion"
                v-model.trim="$v.pjeAmortizacion.$model" 
                :state="pjeAmortizacionValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="pjeAmortizacionFeedback">
                {{ pjeAmortizacionInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>
          </b-form>

          <div slot="footer" v-if="modal">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="save">Grabar</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="goBack">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      v-if= "!modal"
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Rubro from '../shared/abmSelect.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { required, decimal, maxLength, minValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'bien/getField',
  mutationType: 'bien/updateField',
});

export default {
  name: 'BienABM',
  components: {
    appRubro: Rubro,
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    bienId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      noValidar: true,
      codigoValido: null,
      codigoInvalidoMsj: '',
      nombreValido: null,
      nombreInvalidoMsj: '',
      descripcionValida: null,
      descripcionInvalidaMsj: '',
      rubroValido: null,
      rubroInvalidoMsj: '',
      cotizacionValida: null,
      cotizacionInvalidaMsj: '',
      pjeAmortizacionValido: null,
      pjeAmortizacionInvalidoMsj: '',

      rubros: [],
      rubrosList: [],

      labelCols: 2,
      inicializando: false
    }
  },
  computed: {
    ...mapFields([
      'id',
      'codigo',
      'nombre',
      'descripcion',
      'rubro',
      'rubroNombre',
      'cotizacion',
      'pjeAmortizacion'
    ])
  },  
  created() {
    let bienId = 0;

    if (!this.modal) {
      if (this.$route.params){
        if (this.$route.params.id){
          bienId = this.$route.params.id;
        }
      }
    }

    if (this.modal) {
      if (this.bienId) {
        if (this.bienId != 0) {
          bienId = this.bienId;
        }
      }
    }

    this.showSpinner();
    this.inicializando = true;
    this.$store.dispatch('bien/inicializar', bienId)
      .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error))
      .finally(() => {
        this.hideSpinner();
        this.inicializando = false;
      })
  },  
  methods: {
    getDatosAdicionales() {
      this.$store.dispatch('bienesRubros/getList')
      .then(() => {
          this.rubros = this.$store.getters['bienesRubros/list']
          this.rubrosList = this.$store.getters['bienesRubros/selectList']
        })
      .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de rubros.'));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'codigo' || validarTodos) {
        if (this.$v.codigo.$error) {
          this.codigoValido = false;
          if (!this.$v.codigo.maxLength) {
            this.codigoInvalidoMsj = 'El código solo puede contener hasta 50 caracteres';
          } 
        } else {
          this.codigoValido = null;
          this.codigoInvalidoMsj = '';
        }
      }

      if (campo == 'nombre' || validarTodos) {
        if (this.$v.nombre.$error) {
          this.nombreValido = false;
          if (!this.$v.nombre.required) {
            this.nombreInvalidoMsj= 'Debe ingresar el nombre del bien.';
          } else if (!this.$v.nombre.maxLength) {
            this.nombreInvalidoMsj = 'El nombre solo puede contener hasta 150 caracteres';
          } 
        } else {
          this.nombreValido = null;
          this.nombreInvalidoMsj = '';
        }
      }
        
      if (campo == 'descripcion' || validarTodos) {
        if (this.$v.descripcion.$error) {
          this.descripcionValida = false;
          if (!this.$v.descripcion.maxLength) {
            this.descripcionInvalidaMsj = 'La descripción solo puede contener hasta 5000 caracteres';
          }
        } else {
          this.descripcionValida = null;
          this.descripcionInvalidaMsj = '';
        }
      }

      if (campo == 'cotizacion' || validarTodos) {
        if (this.$v.cotizacion.$error) {
          this.cotizacionValida = false;
          if (!this.$v.cotizacion.required) {
            this.cotizacionInvalidaMsj= 'Debe ingresar la cotización del bien.';
          } else if (!this.$v.cotizacion.decimal || !this.$.cotizacion.minValue) {
            this.cotizacionInvalidaMsj = 'La cotización ingresada no es válida.';
          } 
        } else {
          this.cotizacionValida = null;
          this.cotizacionInvalidaMsj = '';
        }
      }

      if (campo == 'pjeAmortizacion' || validarTodos) {
        if (this.$v.pjeAmortizacion.$error) {
          this.pjeAmortizacionValido = false;
          if (!this.$v.pjeAmortizacion.decimal || !this.$.pjeAmortizacion.minValue) {
            this.pjeAmortizacionInvalidoMsj = 'El porcentaje de amortización ingresado no es válida.';
          } 
        } else {
          this.pjeAmortizacionValido = null;
          this.pjeAmortizacionInvalidoMsj = '';
        }
      }
    },
    save () {
      let save = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let rubroError = true;
      if (this.rubro) {
        if (this.rubro.id) {
          if (this.rubro.id != 0) {
            rubroError = false;
          }
        }
      }
      if (rubroError) {
        save = Boolean(false);
        this.rubroValido = false;
        this.rubroInvalidoMsj = "Debe seleccionar el rubro correspondiente.";
      }

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        if (save) {
          this.showSpinner();
          this.$store.dispatch('bien/save')
            .then(()  => {
              if (!this.modal) {
                this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light');
              } else {
                this.$emit('updateBien', 
                  this.$store.getters['bien/bien']);
              }
            })
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        }
      } 
    },
    goBack() {
      if (!this.modal) {
        this.$router.go(-1);
      } else {
        this.$emit('closeBien');
      }
    },
    goList() {
      this.$router.push({ name: "Bienes" });
    },
    rubroActualizado(rubroNombre) {
      if (!this.inicializando) {
        let rubro = null;
        if (rubroNombre) {
          rubro = this.getSelected(this.rubros, rubroNombre);
        }
        this.$store.dispatch('bien/setRubro', rubro);

        this.rubroValido = null;
        this.rubroInvalidoMsj = '';
      }
    },
  },
  watch: {
  },
  validations: {
    codigo: {
      // required,
      maxLength: maxLength(50)
    },
    nombre: {
      required,
      maxLength: maxLength(150)
    },
    descripcion: {
      // required,
      maxLength: maxLength(5000)
    },
    cotizacion: {
      required,
      decimal,
      minValue: minValue(0)
    },
    pjeAmortizacion: {
      decimal,
      minValue: minValue(0)
    },
  },  
}
</script>

<style>
</style>
